<template>
  <router-view></router-view>
  <!-- <ResetPassword msg="Welcome to Your Vue.js App"/> -->
</template>

<script>
// import ResetPassword from './components/ResetPassword.vue'

export default {
  name: 'App',
  components: {
    // ResetPassword
  }
}
</script>

<style>
</style>
